export interface RankingItem {
  rank: number;
  name: string;
  points: string;
  change: 'up' | 'down' | 'same';
}

export interface RankingCategory {
  title: string;
  icon: string;
  items: RankingItem[];
}

export const rankings: RankingCategory[] = [
  {
    title: 'FIFA世界排名',
    icon: 'ri-football-line',
    items: [
      { rank: 1, name: '阿根廷', points: '1858.3', change: 'same' },
      { rank: 2, name: '法国', points: '1840.6', change: 'same' },
      { rank: 3, name: '巴西', points: '1825.1', change: 'up' },
      { rank: 4, name: '英格兰', points: '1812.4', change: 'down' },
      { rank: 5, name: '葡萄牙', points: '1798.7', change: 'same' },
      { rank: 6, name: '西班牙', points: '1785.2', change: 'up' },
      { rank: 7, name: '荷兰', points: '1772.8', change: 'same' },
      { rank: 8, name: '德国', points: '1760.3', change: 'down' },
    ],
  },
  {
    title: 'NBA实力榜',
    icon: 'ri-basketball-line',
    items: [
      { rank: 1, name: '波士顿凯尔特人', points: '64胜18负', change: 'same' },
      { rank: 2, name: '丹佛掘金', points: '60胜22负', change: 'up' },
      { rank: 3, name: '俄克拉荷马雷霆', points: '58胜24负', change: 'up' },
      { rank: 4, name: '达拉斯独行侠', points: '55胜27负', change: 'down' },
      { rank: 5, name: '密尔沃基雄鹿', points: '54胜28负', change: 'same' },
      { rank: 6, name: '纽约尼克斯', points: '52胜30负', change: 'up' },
      { rank: 7, name: '明尼苏达森林狼', points: '51胜31负', change: 'down' },
      { rank: 8, name: '洛杉矶湖人', points: '49胜33负', change: 'up' },
    ],
  },
  {
    title: 'ATP单打排名',
    icon: 'ri-base-station-line',
    items: [
      { rank: 1, name: '辛纳', points: '11830', change: 'same' },
      { rank: 2, name: '阿尔卡拉斯', points: '9720', change: 'same' },
      { rank: 3, name: '德约科维奇', points: '8460', change: 'same' },
      { rank: 4, name: '梅德韦杰夫', points: '7215', change: 'up' },
      { rank: 5, name: '兹维列夫', points: '6885', change: 'down' },
      { rank: 6, name: '卢布列夫', points: '5420', change: 'same' },
      { rank: 7, name: '鲁内', points: '4890', change: 'up' },
      { rank: 8, name: '弗里茨', points: '4235', change: 'up' },
    ],
  },
];